import { inject } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { GlobalsService } from "../services";
import { HSOverlay } from "preline/dist";

declare let DataTable: any;
export let isOpen: boolean;

export const themeUI = () => {
  const globals: GlobalsService = inject(GlobalsService)
  const router: Router = inject(Router);

  router.events.subscribe((event: any) => {
    if (event instanceof NavigationEnd) {
      globals.config.url.next(event.url);
       
      (window as any).HSStaticMethods?.autoInit();
      document.querySelectorAll('.hs-overlay').forEach((el: any) => HSOverlay.open(el));
    }
  });
}


export const getCSSVariableValue = (variableName: string) => {
    return getComputedStyle(document.documentElement).getPropertyValue(variableName);
  }
  
  
  export const scrollToElement = (elementId: string) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }
  
  export const sortObjectsByDate = (array: any[], key: string) => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    const todayStr = today.toDateString();
    const yesterdayStr = yesterday.toDateString();
  
  
    const todayObjects: any[] = [];
    const yesterdayObjects: any[] = [];
    const otherObjects: any[] = [];
  
    array.forEach(obj => {
      const date = new Date(obj.date);
      const dateStr = date.toDateString();
  
      if (dateStr === todayStr) {
        todayObjects.push(obj);
      } else if (dateStr === yesterdayStr) {
        yesterdayObjects.push(obj);
      } else {
        otherObjects.push(obj);
      }
    });
  
    return {
      today: todayObjects,
      yesterday: yesterdayObjects,
      others: otherObjects
    };
  }
  
export const initDatatable = (
    id: string,
    search = false,
    pageinate = true,
    autowidth = true,
    processing = true,
    ordering = true
) => {
  setTimeout(() => {
    const table = new DataTable(`#${id}`, {
        pagingType: 'full_numbers',
        searching: search,
        paging: pageinate,
        ordering: ordering,
        autoWidth: autowidth,
        processing: processing,
        info: true,
        order: [[6, 'desc']],
        // scrollX: true,
        lengthChange: true,
        language: {
            searchPlaceholder: "Search for records..."
        },
        lengthMenu: [[15, 30, 45, 60, -1], ["15 Rows", "30 Rows", "45 Rows", "60 Rows", "Everything"]],
        layout: {
            bottomEnd: ['info', 'paging'],
            bottomStart: null,
            topStart: null,
            topEnd: null
        },
    });
  }, 100)
  // if(!$.fn.DataTable.isDataTable(`#${id}`)) {
  // }
}

export const toogleLivechat = () => {
  if(isOpen) {
    document.body.classList.remove("show-chatbot")
    isOpen = false;
  } else {
    document.body.classList.toggle("show-chatbot");
    isOpen = true;
  }
  return isOpen
}

